import React from "react";
import "./SectionHeader.css";
const SectionHeader = ({ title, halfWidth, bottomMargin, marginTop }) => {
  return (
    <div
      className={
        !halfWidth
          ? "section-header__container"
          : "section-header__container section-header__half-width"
      }
    >
      <div
        className="section-header__title"
        style={
          bottomMargin && marginTop
            ? { marginBottom: "1rem", marginTop: "5rem" }
            : bottomMargin
            ? { marginBottom: "1rem" }
            : marginTop
            ? { marginTop: "5rem" }
            : {}
        }
      >
        {title}
      </div>
    </div>
  );
};

export default SectionHeader;
